import { API_LOGIN, API_LOGOUT } from "../../utils/api/ApiConstant";
import { defaultAxios } from "../../utils/api/axios";
import showToast from "../../utils/toastUtil";
import { userAction } from "./user-slice";
import { uiActions } from "../ui/ui-slice";
import { decryptPayload, encryptPayload } from "../../shared/helper/common";
import { getAxios, postAxios } from "../../shared/Services/commonService";
import store, { dispatch } from "../../store";

export const loginUser = async (dispatch, payload) => {
  try {
    dispatch(uiActions.setLoading(true));
    const { password } = payload;
    const encryptedPass = encryptPayload(password);
    const body = {
      ...payload,
      password: password,
    };
    const data = await defaultAxios.post(API_LOGIN, body);
    console.log("data", data);
    if (data?.success) {
      dispatch(userAction.setToken(data?.data?.access_token));
      // dispatch(userAction.updateUser(decryptPayload(data?.data)));
      // dispatch(userAction.updateUser(data?.data));
      dispatch(uiActions.setHeading("Dashboard"));
      showToast.success(data?.message);
    } else {
      showToast.error(data?.message);
    }
    dispatch(uiActions.setLoading(false));
  } catch (err) {
    dispatch(uiActions.setLoading(false));
    console.error("Login failed:", err);
  }
};

// const postLogout = async () => {
//   await defaultAxios.post(API_LOGOUT);
// };

const clearStorage = () => {
  dispatch(userAction.clearUser());
  dispatch(uiActions.clearAllModals());
};

export const logoutUser = async () => {
  try {
    // await postLogout();
    // defaultAxios.post(API_LOGOUT);

    const token = store.getState()?.user?.token;

    await fetch(`http://51.159.0.19:8001/api${API_LOGOUT}`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    clearStorage();
    showToast.success("Logout.");
  } catch (error) {
    showToast.error(error?.data?.message);
  }
};

let isLogoutInProgress = false;

export const handleAxiosError = async (error) => {
  if (isLogoutInProgress) {
    return Promise.reject(error);
  }

  if (error?.message === "Network Error" || error?.response?.status === 401) {
    isLogoutInProgress = true;

    try {
      logoutUser();
      // if (error?.response?.status === 401) {
      //   showToast.warning("Session expired. Please log in again.");
      // }
    } catch (e) {
      console.error("Logout error:", e);
    } finally {
      isLogoutInProgress = false;
    }
  }

  return Promise.reject(error?.response?.data);
};
